
export const getCurrentLanguage = () =>{
    let language = localStorage.getItem("language") ? JSON.parse(localStorage.getItem("language")) : "km";
    return language;
}